import React from 'react'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

type MarkdownMessageProps = {
    text: string
    className?: string
}

const markdownBaseClassName = [
    'max-w-none text-[15px] leading-7 text-slate-800',
    '[&_p]:my-3 [&_p:first-child]:mt-0 [&_p:last-child]:mb-0',
    '[&_strong]:font-semibold [&_strong]:text-slate-900',
    '[&_em]:italic',
    '[&_a]:text-blue-700 [&_a]:underline [&_a]:underline-offset-2',
    '[&_ul]:my-3 [&_ul]:list-disc [&_ul]:pl-6',
    '[&_ol]:my-3 [&_ol]:list-decimal [&_ol]:pl-6',
    '[&_li]:my-1.5',
    '[&_blockquote]:my-4 [&_blockquote]:border-l-4 [&_blockquote]:border-slate-300 [&_blockquote]:pl-4 [&_blockquote]:text-slate-600',
    '[&_hr]:my-4 [&_hr]:border-slate-200',
    '[&_h1]:mt-5 [&_h1]:mb-3 [&_h1]:text-xl [&_h1]:font-semibold [&_h1]:text-slate-900',
    '[&_h2]:mt-5 [&_h2]:mb-3 [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:text-slate-900',
    '[&_h3]:mt-4 [&_h3]:mb-2 [&_h3]:text-base [&_h3]:font-semibold [&_h3]:text-slate-900',
    '[&_table]:min-w-full [&_table]:border-collapse [&_table]:rounded-lg',
    '[&_thead]:bg-slate-100',
    '[&_th]:border [&_th]:border-slate-200 [&_th]:px-3 [&_th]:py-2 [&_th]:text-left [&_th]:text-sm [&_th]:font-semibold [&_th]:whitespace-nowrap',
    '[&_td]:border [&_td]:border-slate-200 [&_td]:px-3 [&_td]:py-2 [&_td]:align-top [&_td]:text-sm',
    '[&_code]:rounded [&_code]:bg-slate-100 [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-[13px]',
    '[&_pre]:my-4 [&_pre]:overflow-x-auto [&_pre]:rounded-xl [&_pre]:bg-slate-900 [&_pre]:p-4 [&_pre]:text-slate-100',
    '[&_pre_code]:bg-transparent [&_pre_code]:p-0 [&_pre_code]:text-inherit',
].join(' ')

export default function MarkdownMessage({ text, className = '' }: MarkdownMessageProps) {
    return (
        <div className={`${markdownBaseClassName} ${className}`.trim()}>
            <Markdown
                remarkPlugins={[remarkGfm]}
                components={{
                    a: ({ node: _node, ...props }) => (
                        <a {...props} target="_blank" rel="noreferrer noopener" />
                    ),
                    table: ({ node: _node, ...props }) => (
                        <div className="my-4 overflow-x-auto rounded-lg border border-slate-200">
                            <table {...props} className="min-w-full border-collapse" />
                        </div>
                    ),
                }}
            >
                {text}
            </Markdown>
        </div>
    )
}
